'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isSameDay = require('./is-same-day.js');

function isToday(date, timeZone) {
  return isSameDay.isSameDay(date, new Date(), timeZone);
}

exports.isToday = isToday;
